
export const catalogReducer = (state = [], action) => {

    switch (action.type) {
        case '[CATALOG] Load list':
            return {
                ...state,
                catalog: action.payload
            }

        case '[CATALOG] Load list group':
            return {
                ...state,
                catalogGroup: action.payload
            }

        case '[CATALOG] Load categorias':
            return {
                ...state,
                categorias: action.payload
            }

        case '[CATALOG] Set categoria temp':
            return {
                ...state,
                id_categoria_temp: action.payload
            }

        default:
            return state
    }


}